import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Col, DatePicker, Row } from "antd";
import { Input } from "antd";
import { Tooltip } from "antd";
import { Form } from "antd";
import dayjs from "dayjs";
import React, { FC, useCallback } from "react";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../../utils/notificationUtils";
import { Button } from "antd";

type PortalRegistrationCghsProps = {
  form: any;
  editRegId: boolean;
  handleEditRegId: any;
  handleSubmitId: any;
  handleRegistration: any;
  portalData: any;
  handlePreviewDocument: any;
  cardDocumentUrl: any;
  showRegistrationId?: boolean;
};

const PortalRegistrationCghs: FC<PortalRegistrationCghsProps> = ({
  form,
  editRegId,
  handleEditRegId,
  handleRegistration,
  handleSubmitId,
  portalData,
  handlePreviewDocument,
  cardDocumentUrl,
  showRegistrationId,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  const buttonStyle = React.useMemo(
    () => ({
      backgroundColor: "rgb(0, 76, 143)",
      color: "#fff",
      boxShadow: "0px 2px 8px 0px #00000040",
    }),
    []
  );

  const handleUpdateId = useCallback(async () => {
    try {
      const values = await form.validateFields();
      await handleSubmitId(values);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please fill all details before submitting");
      } else {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    }
  }, [form, handleSubmitId]);

  const handleSubmit = useCallback(async () => {
    await handleRegistration();
  }, [handleRegistration]);

  return (
    <div style={{ marginTop: "-23px" }}>
      <Form
        form={form}
        onFinish={handleSubmit}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={7} lg={7} xl={7}>
            <Form.Item
              label="BENEFICIARY ID"
              name="beneficiaryId"
              style={{ marginTop: "1.7rem" }}
              rules={[
                {
                  required: true,
                  message: "Please input BENEFICIARY ID",
                },
              ]}
            >
              <Input
                placeholder="Please input BENEFICIARY ID"
                disabled={portalData?.schemeRegistrationId}
                style={{ color: "black" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="REGISTRATION DATE"
              name="registrationDate"
              style={{ marginTop: "1.7rem", color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input Registration Date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={dateFormat}
                disabled={portalData?.schemeRegistrationId}
                disabledDate={(current) => {
                  const now = dayjs().endOf("day");
                  const firstAllowedDate = dayjs().startOf("year");

                  return (
                    current.isBefore(firstAllowedDate, "day") ||
                    current.isAfter(now, "day")
                  );
                }}
              />
            </Form.Item>
          </Col>

          {portalData?.schemeRegistrationId || showRegistrationId ? (
            !editRegId ? (
              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item
                  label="REGISTRATION ID"
                  name="registrationId"
                  style={{ marginTop: "1.7rem", color: "black" }}
                  rules={[
                    {
                      required: true,
                      message: "Please input REGISTRATION ID",
                    },
                  ]}
                >
                  <Input
                    placeholder="Please input REGISTRATION ID"
                    disabled={
                      portalData?.schemeRegistrationId || showRegistrationId
                    }
                    style={{ color: "black" }}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item
                  label="REGISTRATION ID"
                  name="registrationId"
                  style={{ marginTop: "1.7rem", color: "black" }}
                  rules={[
                    {
                      required: true,
                      message: "Please input REGISTRATION ID",
                    },
                    {
                      pattern: /^\S+$/,
                      message: "REGISTRATION ID must not contain spaces",
                    },
                  ]}
                >
                  <Input
                    placeholder="Please input REGISTRATION ID"
                    //   disabled={portalData?.schemeRegistrationId}
                    style={{ color: "black" }}
                  />
                </Form.Item>
              </Col>
            )
          ) : (
            <></>
          )}
          {portalData?.schemeRegistrationId || showRegistrationId ? (
            !editRegId ? (
              <>
                {/* Hidden input element for copying */}
                <input
                  type="text"
                  id="hidden-copy-input"
                  value={portalData?.schemeRegistrationId || "-"}
                  readOnly
                  style={{ position: "absolute", left: "-9999px" }}
                />

                {/* Copy Icon */}
                <Tooltip title="Copy Registration ID">
                  <CopyOutlined
                    style={{
                      paddingTop: "24px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const hiddenInput: any =
                        document.getElementById("hidden-copy-input");
                      if (hiddenInput) {
                        hiddenInput.select();

                        try {
                          const successful = document.execCommand("copy");
                          if (successful) {
                            successMessage(
                              "Registration ID copied to clipboard!"
                            );
                          } else {
                            errorMessage("Failed to copy Registration ID.");
                          }
                        } catch (err) {
                          errorMessage("Copy command failed!");
                        }
                      } else {
                        warningMessage("No Registration ID to copy!");
                      }
                    }}
                  />
                </Tooltip>
                {!portalData?.casePreAuthCghs?.claimId ? (
                  <Tooltip title="Edit Registration ID">
                    <EditOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={handleEditRegId}
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <Tooltip title="Cancel Update Registration ID">
                  <CloseOutlined
                    style={{
                      paddingTop: "24px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={handleEditRegId}
                  />
                </Tooltip>
                <Tooltip title="Save Registration ID">
                  <CheckOutlined
                    style={{
                      paddingTop: "24px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={handleUpdateId}
                  />
                </Tooltip>
              </>
            )
          ) : (
            <></>
          )}

          {cardDocumentUrl ? (
            <Col
              xs={24}
              sm={12}
              md={2}
              lg={2}
              xl={2}
              className="card-preview"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "14px", paddingBottom: "10px" }}>
                CGHS Card
              </span>
              <Tooltip title="Preview CGHS Card">
                <EyeOutlined
                  style={{
                    paddingBottom: "8px",
                    fontSize: "20px",
                    marginLeft: "8px",
                    cursor: "pointer",
                  }}
                  onClick={handlePreviewDocument}
                />
              </Tooltip>
            </Col>
          ) : (
            <></>
          )}
        </Row>

        {portalData?.schemeRegistrationId ||
        (portalData?.visitStagesName?.toLowerCase()?.toString() ==
          "portal registration" &&
          (portalData?.stateName?.toLowerCase()?.toString() == "initiated" ||
            portalData?.stateName?.toLowerCase()?.toString() == "submitted" ||
            portalData?.stateName?.toLowerCase()?.toString() ==
              "manually submitted")) ? (
          <></>
        ) : (
          <Row justify="end" style={{ marginBottom: "0" }}>
            <Form.Item wrapperCol={{ span: 16 }} style={{ marginBottom: "0" }}>
              {
                <Button type="primary" htmlType="submit" style={buttonStyle}>
                  PORTAL REGISTRATION
                </Button>
              }
            </Form.Item>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default React.memo(PortalRegistrationCghs);
